import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, output, Output, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  standalone: true,
  imports: [FormsModule, CommonModule]
})

export class ConfirmModal implements OnChanges {

  @Input() question: string = '';
  @Input() content: string = '';
  @Input() objectId: string = '';
  @Input() visibility: boolean = false;
  @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter(false);
  @Output() onConfirm: EventEmitter<({ _id: string })> = new EventEmitter();
  @Output() onCancel: EventEmitter<false> = new EventEmitter(false);

  emit(id: string) {
    this.onConfirm.emit({ _id: id });
    this.closeModal();
  }

  closeModal() {
    this.onCancel.emit(false)
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
}